$(() => {
  /**
   * jQuery plugin for a Race Roster event registration shipping form.
   * @param options
   * @returns {*}
   */
  $.fn.eventRegistrationShipping = function Plugin(options) {
    const defaults = {
      autocompleteService: 'google',
    };

    const toggleShipping = (settings, event) => {
      const $this = $(event.currentTarget);

      if ($this.val() === '1') {
        settings.elements.$pickUpContainer.addClass('hidden');
        settings.elements.$shippingContainer
          .removeClass('hidden')
          .prop('disabled', false);
      } else {
        settings.elements.$pickUpContainer.removeClass('hidden');
        settings.elements.$shippingContainer
          .addClass('hidden')
          .prop('disabled', true);
      }
    };

    /**
     * Fire up
     */
    const initialize = function initialize() {
      const settings = $.extend(true, {}, defaults, options);
      const $container = $(this);

      settings.elements = {
        $container,
        $shippingToggle: $container.find('[data-js="shipping-toggle"]'),
        $pickUpContainer: $container.find('[data-js="pick-up-container"]'),
        $shippingContainer: $container.find('[data-js="shipping-container"]'),
        $shippingFields: $container.find('[data-js-shipping-fields]'),
      };

      settings.elements.$shippingToggle
        .on('change', (event) => toggleShipping(settings, event))
        .filter(':checked')
        .trigger('change');

      settings.elements.$shippingFields.geography({
        autocompleteService: settings.autocompleteService,
      });
    };

    return this.each(initialize);
  };
});
